import React from 'react';

export const Button = ({
  type = 'button',
  size = '',
  variant = '',
  isOutline = false,
  color = 'white',
  children,
  btnClasses = '',
  icon = null,
  rounded = false,
  ...rest
}) => {
  return (
    <button
      {...rest}
      type={type}
      className={`btn--${size} bg--${variant} ${
        isOutline
          ? `border-full--${variant} bg--transparent text--${variant}`
          : `text--${color}`
      } ${rounded ? `radius--full` : `radius--sm`} ${btnClasses}`}
    >
      <span className="d--flex">{icon}</span> {children}
    </button>
  );
};
